export default __webpack_public_path__ + "static/media/logo.d889a96f.png";